import React from 'react';
import { ExternalLink, Clock } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { Separator } from '../ui/separator';
import useMatchScoreData from '../../hooks/useMatchScoreData';
import useWinningTeam from '../../hooks/useWinningTeam';
import Item from './Item';

const MarqueeItem = ({ match }) => {
  const isComplete = match.match.status === 'COMPLETE';
  const matchScoreData = useMatchScoreData(match);

  if (matchScoreData) {
    match.outcomes[1].score = matchScoreData.competitions[0].competitors[0].score;
    match.outcomes[0].score = matchScoreData.competitions[0].competitors[1].score;
  }

  const winningTeam = useWinningTeam(match, isComplete);

  return (
    <div className="inline-flex flex-shrink-0 mx-3 my-2 cursor-pointer group">
      <Card className="min-w-[320px] bg-card/95 backdrop-blur-sm transition-[color,background-color,border-color,box-shadow,transform] duration-base ease-out [@media(hover:hover)_and_(pointer:fine)]:hover:shadow-md [@media(hover:hover)_and_(pointer:fine)]:hover:border-primary/40">
        <CardContent className="p-4">
          <div className="flex justify-between items-center mb-3">
            {!isComplete ? (
              <Badge variant="accent" className="gap-1">
                <Clock className="w-3 h-3" />
                LIVE
              </Badge>
            ) : (
              <Badge variant="muted">FINAL</Badge>
            )}
            <Button size="sm" variant="ghost" className="h-6 w-6 p-0 opacity-60 hover:opacity-100" asChild>
              <a href={match.match.liveScoreURL} target="_blank" rel="noopener noreferrer">
                <ExternalLink className="w-3 h-3" />
              </a>
            </Button>
          </div>

          <div className="flex items-center justify-between">
            <Item outcome={match.outcomes[0]} isLeft={true} isComplete={isComplete} winningTeam={winningTeam} />
            <div className="flex flex-col items-center mx-4 gap-1">
              <span className="text-lg font-bold text-muted-foreground">VS</span>
              <Separator className="w-8" />
            </div>
            <Item outcome={match.outcomes[1]} isLeft={false} isComplete={isComplete} winningTeam={winningTeam} />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default MarqueeItem;
